<template>
    <div class="pageContent">
        <div class="reportUnfinished">
            <div class="unfinishedImg">
                 <img src="../../assets/unfinished.png" alt="">
            </div>
            <span class="unfinishedSpan">检查结果未完成</span>
            <div class="describe">
                <span>检查报告完成后</span>
                <span>我们将第一时间通过公众号通知您</span>
                <span>请您留意公众号推重消息</span>
            </div>
        </div>
        <div
        class="allReport"
        @click="toReportList"
      >< 全部报告</div>
    </div>
</template>
<script>
export default {
  name: "reportUnfinished",
  data() {
    return {};
  },
  methods:{
    toReportList(){
      this.$router.push({ path: '/reportList' })
    }
  }
};
</script>
<style scoped>
@import "../../style/unfinished/index.css";
</style>


